// UQ-de-DE
module.exports = {
  "forTest": "test for UQ-de-DE",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Offizielle Styles",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Sortieren",
  "text_filter": "Filter",
  "text_styling_book_search_results_number": "{total} Ergebnisse",
  "text_active_filters": "Angewandte Filter",
  "text_styling_book_clear_all_filters": "Alles entfernen",
  "text_styling_book_search_by_feature": "Nach Eigenschaften suchen",
  "text_styling_book_search_by_category": "Nach Kategorie suchen",
  "text_styling_book_staff_customer_filter_all": "Alle",
  "text_styling_book_search_by_coordinate": "Nach Koordinaten suchen",
  "text_styling_book_staff_customer_filter_title": "Mitarbeitende / Kundschaft",
  "text_styling_book_search_by_height": "Nach Körperlänge suchen",
  "text_styling_book_search_by_hashtag": "Nach Hashtag suchen",
  "text_styling_book_staff_customer_filter_customer_styling": "Style der Kundschaft",
  "text_styling_book_staff_customer_filter_staff_styling": "Style der Mitarbeitenden",
  "text_apply_search_filter": "Anwenden",
  "text_styling_book_no_results": "Keine Ergebnisse",
  "text_error_title": "Dienst vorübergehend nicht verfügbar",
  "text_503_error_description-1": "Bitte entschuldige, leider ist ein Fehler aufgetreten.",
  "text_503_error_description-2": "Bitte kehre später zu dieser Seite zurück oder gehe mithilfe der Schaltfläche „Zurück“ deines Browsers auf die vorherige Seite.",
  "text_503_error_instruction": "Bitte besuche {text_contactus} bei weiteren Fragen.",
  "text_styling_book_go_to_top": "UNIQLO Homepage",
  "text_contactus": "Kontakt",
  "text_wishlist": "Wunschliste",
  "text_membership_info": "Mein Konto",
  "text_wearing_items": "Artikel tragen",
  "text_color": "Farbe",
  "text_size": "Größe",
  "text_stylehint_non_listed_items_message_01": "Die oben aufgeführten Produkte sind entweder nicht mehr erhältlich oder nicht von UNIQLO.",
  "text_styling_book_related_styling_title": "Ähnliche Styles",
  "text_style_styling_date_update": "Update",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "{price} €",
  "text_404": "Seite nicht gefunden",
  "text_official_styling_top_page_link": "Offizielle Styles",
  "text_stylehint_top_page_link": "StyleHint top page",
  "text_breadcrumbs_top": "UNIQLO Homepage",
  "text_a11y_close": "Schließen",
  "text_log_in": "Anmelden",
  "text_app_update_dialog_cancel": "Stornieren",
  "text_menu": "Menü",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. Alle Rechte vorbehalten.",
  "text_stylehintapp": "StyleHint App",
  "text_styling_book_official_styling_page_title": "Offizielle Styles",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Neuheiten",
  "text_styling_book_sort_popular": "Am beliebtesten",
  "text_styling_book_search_by_color": "Nach Farbe suchen",
  "text_filter_clear_all_category": "Alle Kategorien entfernen",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Alle anzeigen",
  "text_error_description": "Leider ist ein Systemfehler aufgetreten. Bitte versuchen Sie es noch einmal oder kommen Sie später wieder.",
  "text_system_error": "Systemfehler",
  "text_ok": "OK",
  "text_login_required": "Anmeldung erforderlich",
  "text_login_request": "Bitte melde dich an, um fortzufahren.",
  "text_error_failed_sort_product": "Produkte konnten anhand der gewählten Kriterien nicht sortiert werden. Bitte versuchen Sie noch einmal, sie zu sortieren.",
  "text_error_failed_update_filter_criteria": "Die Filterkriterien konnten nicht aktualisiert werden. Bitte versuchen Sie es noch einmal.",
  "text_meta_title_postfix": "| UNIQLO DE",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Damen",
  "text_styling_book_meta_men": "Herren",
  "text_styling_book_meta_kids": "Kinder",
  "text_styling_book_meta_baby": "Babys",
  "text_styling_book_official_gender_meta_description": "Erkunde unser Lookbook und entdecke die Styles der Saison. Bestelle komplette Looks oder speichere Favoriten für später.",
  "text_styling_book_official_gender_meta_title": "Erkunde aktuelle Looks | {gender} | Offizielles Styling {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender} 「{filterOptions}」 Styling-Ideen {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Entdecke Styling-Ideen für {gender} {filterOptions}」 mit modernen Designs von {brand}. Erfahre wie du Styles perfekt kombinierst.",
  "text_styling_book_official_detail_meta_title": "Entdecke Looks für 「{officialProducts}」 {uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Entdecke die neuen Looks der Saison für 「{officialProducts}」und bestelle jetzt das komplette Outfit auf {brand}.com.",
  "text_styling_book_stylehint_gender_meta_title": "Entdecke neue Styling-Ideen | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Lass dich inspirieren! Stöbere durch Styles für {gender} von unseren Kund:innen und Mitarbeitenden von {brand} in der StyleHint App.",
  "text_styling_book_stylehint_filter_meta_title": "Styling-Ideen für 「{filterOptions}」 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Outfits von {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Outfits von {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Outfits von {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Entdecke Styling-Ideen für「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Entdecke Outfits von {staffName}({height}) vom {brand}({storeName}). Erfahre wie unserer Mitarbeitenden Styles perfekt kombinieren.",
  "text_styling_book_stylehint_ins_user_meta_description": "Entdecke Outfits von 「{userName}」von Instagram mit {brand}s Produkten. Erfahre wie andere User:innen moderne Styles kreieren.",
  "text_styling_book_stylehint_customer_user_meta_description": "Entdecke moderne Outfits von {userName} ({height}) mit Produkten von {brand}. Schaue dir die Artilel im Onlineshop an.",
  "text_styling_book_stylehint_detail_meta_description": "Entdecke neue Styles für 「{stylehintProducts}」von unseren Kund:innen und Mitarbeitenden von  {brand}. Bestelle jetzt das komplette Outfit auf {brand}.com.",
  "text_styling_book_stylehint_filter_meta_description": "Entdecke 「{searchCount}」Outfits von「{filterOptions}」 mit Produkten von {brand}. Entdecke aktuelle Neuheiten und Bestseller online.",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} LOOKBOOK Outfits Style-ID: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} LOOKBOOK Styling-Ideen Style-ID: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Entdecke Styling-Ideen von「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Entdecke Outfits von「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Idées de tenues pour {gender}「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Styling-Ideen für {gender} 「{feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Bitte entschuldigen Sie. Da ist leider ein Fehler passiert. Bitte kehren Sie später zu dieser Website zurück oder gehen Sie mithilfe der Schaltfläche „Zurück“ Ihres Browsers auf die vorherige Webseite.",
  "text_styling_book_meta_official_styling": "Ideen für Stylings",
  "text_styling_book_meta_stylehint": "Ideen für Outfits",
  "text_limited_offer_until_date": "Begrenztes Angebot bis {date}",
  "text_online_store_exclusive_limited_offer_until_date": "Exklusiv im Online-Shop: begrenztes Angebot bis {date}",
  "text_app_membership_exclusive_limited_offer_until": "App-Mitglied begrenzt bis {date}",
  "text_csoon_early": "Erhältlich ab Anfang {month}",
  "text_csoon_mid": "Erhältlich ab Mitte {month}",
  "text_csoon_late": "Erhältlich ab Ende {month}",
  "text_men": "Herren",
  "text_women": "Damen",
  "text_kids": "Kinder",
  "text_baby": "Baby",
  "text_unisex": "Unisex",
  "text_app_membership_exclusive_limited_offer": "App-Mitglied begrenzt",
  "text_styling_book_gender_menu_kids_and_baby": "Kinder / Babys",
  "text_styling_book_meta_kids_and_baby": "",
  "text_a11y_favorites_add": "Zur Wunschliste hinzufügen",
  "text_close": "Schließen",
  "text_error_wishlist_max": "Sie können den Artikel nicht zu Ihrer Wunschliste hinzufügen, weil dann die maximal zulässige Anzahl von 999 Artikeln in der Wunschliste überschritten würde.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Kein Bild",
  "text_wearing_size_code01": "Reale Größe: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "Deutsch",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "Dieses Produkt wurde aus dem Sortiment genommen.",
  "text_product_display_markdown": "",
  "text_color_white": "Weiß",
  "text_color_gray": "Grau",
  "text_color_black": "Schwarz",
  "text_color_pink": "Pink",
  "text_color_red": "Rot",
  "text_color_orange": "Orange",
  "text_color_beige": "Beige",
  "text_color_brown": "Braun",
  "text_color_yellow": "Gelb",
  "text_color_green": "Grün",
  "text_color_blue": "Blau",
  "text_color_purple": "Violett",
  "text_promotion": "Sonderangebot",
  "text_styling_promotion_hashtag": "Sonderangebot",
  "text_coming_soon": "Demnächst verfügbar",
  "text_markdown": "Preissenkung",
  "text_multibuy_markdown": "Multibuy, Preissenkung",
  "text_multibuy_limited_offer_until_date": "Multibuy, begrenztes Angebot bis {date}",
  "text_app_membership_exclusive_multi_buy_until": "Mengenrabatt & app-exklusives Angebot bis zum {date}",
  "text_app_membership_exclusive_multi_buy": "Mengenrabatt & app-exklusives Angebot",
  "text_app_membership_exclusive_limitedoffers_until": "Online & app-exklusives Angebot bis zum {date}",
  "text_item_preorder_color_size_only": "",
  "text_item_resale_color_size_only": ""
}; // generated at Thu Sep 26 2024 09:27:51 GMT+0800 (Hong Kong Standard Time)